import React from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse } from "antd";
import { FormatDateTime } from "../../../utility/format";
const { Panel } = Collapse;

export default function SmsHistory({ title, language, factupdate, smsdata }) {
  return (
    <>
      <Collapse
        className="container"
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          header={
            <div className="font-thai-b fs-18">
              <img
                src={Api.absoluteUrl(`/icon/mail.svg`)}
                alt={title}
                className="mr-2 mb-1"
              />
              <span className="c-blue text-uppercase">{title}</span>
            </div>
          }
          key="1"
          className="font-thai-r fs-18 my-0"
        >
          {smsdata && smsdata.length > 0 ? (
            smsdata.map((data, index) => {
              let i_color = "c-blue";
              let icon = "";
              if (data.sms_send_seq_name === "REQUEST_ON_SITE") {
                i_color = "c-green";
                icon = "fa-caret-right";
              }
              if (data.sms_send_seq_name === "REQUEST_OFF_SITE") {
                i_color = "c-red";
                icon = "fa-caret-left";
              }
              return (
                <div key={`sms_history_${index}`} className="card mb-2">
                  <div className="card-header c-blue px-2 py-1">
                    <i className={`fas ${icon} mr-1 mt-1 ${i_color}`}></i>
                    {data.message_description} -{" "}
                    <FormatDateTime
                      text={data.sms_send_datetime}
                    ></FormatDateTime>
                    {/* {moment(data.sms_send_datetime).format("DD/MM/YYYY HH:mm")} */}
                  </div>
                  <div className="card-body px-1 py-1">
                    <div className="card-text">
                      <div className="col-12">
                        <span className="pl-0 pr-1">Site Code :</span>
                        <span className="">{data.site_code}</span>
                      </div>
                      <div className="col-12">
                        <span className="pl-0 pr-1">หมายเหตุ :</span>
                        <span className="">{data.remark}</span>
                      </div>
                      <div className="col-12">
                        <span className="pl-0 pr-1">Operator :</span>
                        <span className="">{data.sms_client_name}</span>
                      </div>
                      <div className="col-12">
                        <span className="pl-0 pr-1">ผู้ขอส่ง SMS :</span>
                        <span className="">{data.sms_send_by}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : smsdata && smsdata.length === 0 ? (
            <div className="row justify-content-center">
              <span>ไม่พบข้อมูลการส่ง SMS</span>
            </div>
          ) : null}
        </Panel>
      </Collapse>
    </>
  );
}
